import { render, staticRenderFns } from "./WorkFilesUnit.vue?vue&type=template&id=33117c20&scoped=true"
import script from "./WorkFilesUnit.vue?vue&type=script&lang=js"
export * from "./WorkFilesUnit.vue?vue&type=script&lang=js"
import style0 from "./WorkFilesUnit.vue?vue&type=style&index=0&id=33117c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33117c20",
  null
  
)

export default component.exports